import SideBar from '@/components/dashboard/SideBar';
import { mapState } from 'vuex';
export default {
  name: 'Home',
  components: {
    SideBar
  },
  computed: {
    ...mapState('auth', ['authError'])
  },
  mounted() {
    if (this.authError) {
      this.$bvToast.toast('Unauthorized Access to this page.', {
        title: 'Authorization Error',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 3000
      });
      this.$store.commit('auth/SET_AUTH_ERROR', false);
    }
  }
};